module.exports = __webpack_public_path__ + "static/media/crawling-bw.9309c687.jpg";